<template>
  <div>
    <router-link to="/avalanche">
      <b-button class="componentButton" variant="outline-secondary">
        <span style="font-size: xx-large">
          {{ $t("ui.avalanche") }}
        </span>
        <i class="fas fa-mountain fa-2x"></i>
      </b-button>
    </router-link>
    <br />
    <router-link to="/dangerSign">
      <b-button class="componentButton" variant="outline-secondary">
        <span style="font-size: xx-large">{{
          $t("ui.dangersignTtile") + " "
        }}</span>
        <i class="fas fa-exclamation-triangle fa-2x"></i>
      </b-button>
    </router-link>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
